import { Divider } from '@chakra-ui/react'
import { Destination, DestinationTypes } from '@missionlabs/types'
import { FC } from 'react'

import { ESimActivationFlow } from '../AddDevice/ESimActivationFlow'
import {
    EditDeviceDefaultFields,
    EditDeviceDefaultForm,
    EditDeviceDefaultFormProps
} from './EditDeviceDefaultForm'

export type EditDeviceESimFields = EditDeviceDefaultFields<{
    type: DestinationTypes.eSim
}>

export const defaultValues: EditDeviceESimFields = {
    type: DestinationTypes.eSim,
    label: 'eSIM',
    nonRinging: false
}

export const EditDeviceESimForm: FC<EditDeviceDefaultFormProps<EditDeviceESimFields>> = ({
    values,
    onClose,
    onSubmit
}) => {
    function getValues(data: Destination | undefined): EditDeviceESimFields {
        if (!data) return defaultValues
        return {
            type: data.type,
            label: (data.label || data.name) ?? defaultValues.label,
            nonRinging: data.nonRinging ?? defaultValues.nonRinging
        } as EditDeviceESimFields
    }

    return (
        <EditDeviceDefaultForm<EditDeviceESimFields>
            values={values}
            getValues={getValues}
            onClose={onClose}
            onSubmit={onSubmit}
            canBeDeleted={false}
            data-testid="edit-device-esim-form"
        >
            <Divider />
            <ESimActivationFlow />
        </EditDeviceDefaultForm>
    )
}
